import React from 'react';
import { Clock, Zap, ThermometerSun } from 'lucide-react';
import BookingForm from './BookingForm';

const Hero = () => {
  return (
    <section className="relative min-h-screen pt-20">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/dakar-hero.png"
          alt="VTC Chauffeur privé"
          className="w-full h-full object-cover animate-fade-in"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-6 pt-16 sm:pt-24 pb-24 sm:pb-32">
        <div className="max-w-xl">
          <h1
            className="text-3xl sm:text-4xl md:text-5xl lg:text-[56px] font-light text-white leading-tight mb-4 sm:mb-6 opacity-0 animate-fade-in-up"
            style={{ fontFamily: 'Playfair Display, serif', animationDelay: '0.2s', animationFillMode: 'forwards' }}
          >
            VTC Chauffeur Privé
          </h1>
          <p
            className="text-base sm:text-lg text-white/90 leading-relaxed mb-6 sm:mb-8 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}
          >
            Pour tout type de déplacement au Sénégal.
            Voiture électrique climatisée pour vos événements, transferts aéroport et mise à disposition.
            Partout au Sénégal 🇸🇳
          </p>

          {/* Features */}
          <div
            className="flex flex-wrap gap-4 sm:gap-6 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}
          >
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-white/50 flex items-center justify-center backdrop-blur-sm bg-white/10">
                <Zap className="text-yellow-400" size={18} />
              </div>
              <span className="text-white text-xs sm:text-sm">Voiture électrique</span>
            </div>
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-white/50 flex items-center justify-center backdrop-blur-sm bg-white/10">
                <ThermometerSun className="text-white" size={18} />
              </div>
              <span className="text-white text-xs sm:text-sm">Climatisée</span>
            </div>
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-white/50 flex items-center justify-center backdrop-blur-sm bg-white/10">
                <Clock className="text-white" size={18} />
              </div>
              <span className="text-white text-xs sm:text-sm">Disponible 24/7</span>
            </div>
          </div>
        </div>
      </div>

      {/* Booking Form */}
      <div
        className="relative z-20 max-w-[1200px] mx-auto px-4 sm:px-6 -mt-8 sm:-mt-16 opacity-0 animate-scale-in"
        style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}
      >
        <BookingForm />
      </div>
    </section>
  );
};

export default Hero;
